import React from "react";

const ChefBioContentWrapper = ({ selectedChefBioData }) => {
  return (
    <div className="chef-bio-content-wrapper">
      <div>
        <h1 className="mb-2 chef-bio-head">
          {Object.keys(selectedChefBioData).length > 0 &&
            selectedChefBioData.chefName}
        </h1>
        {Object.keys(selectedChefBioData).length > 0 &&
          selectedChefBioData.chefBioDataParas.length > 0 &&
          selectedChefBioData.chefBioDataParas.map((val, i) => (
            <p key={i}>{val}</p>
          ))}
      </div>
    </div>
  );
};

export default ChefBioContentWrapper;
